import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { API } from '../config';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract token from URL query params (new flow) or hash (legacy)
      const urlParams = new URLSearchParams(location.search);
      const token = urlParams.get('token');
      
      // Also check hash for legacy session_id (backwards compatibility)
      const hash = location.hash;
      const sessionIdMatch = hash?.match(/session_id=([^&]+)/);
      
      if (token) {
        // New token exchange flow
        console.log('AuthCallback: Exchanging token for session...');
        try {
          await axios.post(`${API}/auth/exchange-token`, { token });
          console.log('AuthCallback: Token exchange successful');
          navigate('/dashboard', { replace: true });
        } catch (err) {
          console.error('AuthCallback: Token exchange failed:', err.response?.data || err.message);
          navigate('/?error=auth_failed', { replace: true });
        }
      } else if (sessionIdMatch) {
        // Legacy flow (kept for backwards compatibility)
        const sessionId = sessionIdMatch[1];
        console.log('AuthCallback: Found session_id, exchanging for session...');
        try {
          const response = await axios.post(`${API}/auth/google/session`, { session_id: sessionId });
          console.log('AuthCallback: Session exchange successful:', response.data);
          navigate('/dashboard', { replace: true });
        } catch (err) {
          console.error('AuthCallback: Google auth failed:', err.response?.data || err.message);
          navigate('/?error=auth_failed', { replace: true });
        }
      } else {
        console.log('AuthCallback: No token or session_id found');
        navigate('/', { replace: true });
      }
    };

    processAuth();
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
